/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Name_PlaceholderInputs */

const en_team_share_name_placeholder = /** @type {(inputs: Team_Share_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share Name`)
};

const fr_team_share_name_placeholder = /** @type {(inputs: Team_Share_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom du partage`)
};

const de_team_share_name_placeholder = /** @type {(inputs: Team_Share_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name der Aktien`)
};

const it_team_share_name_placeholder = /** @type {(inputs: Team_Share_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condividi Nome`)
};

const ru_team_share_name_placeholder = /** @type {(inputs: Team_Share_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имя пользователя`)
};

const es_team_share_name_placeholder = /** @type {(inputs: Team_Share_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartir nombre`)
};

const zh_cn2_team_share_name_placeholder = /** @type {(inputs: Team_Share_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`股份名称`)
};

const ja_team_share_name_placeholder = /** @type {(inputs: Team_Share_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シェア名`)
};

const hi_team_share_name_placeholder = /** @type {(inputs: Team_Share_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नाम साझा करें`)
};

const pt_pt2_team_share_name_placeholder = /** @type {(inputs: Team_Share_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartilhar Nome`)
};

/**
* | output |
* | --- |
* | "Share Name" |
*
* @param {Team_Share_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_name_placeholder = /** @type {((inputs?: Team_Share_Name_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Name_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_share_name_placeholder(inputs)
	if (locale === "de") return de_team_share_name_placeholder(inputs)
	if (locale === "it") return it_team_share_name_placeholder(inputs)
	if (locale === "ru") return ru_team_share_name_placeholder(inputs)
	if (locale === "es") return es_team_share_name_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_team_share_name_placeholder(inputs)
	if (locale === "ja") return ja_team_share_name_placeholder(inputs)
	if (locale === "hi") return hi_team_share_name_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_team_share_name_placeholder(inputs)
	return en_team_share_name_placeholder(inputs)
});